import React from 'react';
import PropTypes, { any } from 'prop-types';

import { useSelector } from 'react-redux';
import {
    isClubAdminOrOwner,
    hasSchoolLinked,
} from '../../../../../utils/clubs';
import { useStatsig } from '../../../../hooks/useStatsig';
import Roster from './Roster';
import RosterTabTitleLayout from './RosterTabTitleLayout';

import styles from '../../../../../pages/ClubProfiles/club.scss';

const RosterTabContent = (props) => {
    const {
        clubDetails,
        schoolDetails,
        schoolDetailsState,
        clubType,
        rosterTabState,
        power6Data,
    } = props;

    const auth = useSelector(({ auth }) => auth);
    const { checkGate, featureGates } = useStatsig();

    if (!schoolDetailsState?.complete || !schoolDetailsState?.successful) {
        return null;
    }

    const userIsPowered = auth?.user?.isPowered;
    const isAdminOrOwner = isClubAdminOrOwner(clubDetails);
    const hasRoster = schoolDetails?.roster?.length > 0;
    const isHighSchool = clubDetails?.tierType?.isHighSchool;

    return (
        <div className="row">
            <div className="col-12">
                <div className={`${styles.members}`}>
                    <>
                        {(hasRoster || !isHighSchool) && (
                            <RosterTabTitleLayout
                                schoolDetails={schoolDetails}
                                rosterTabState={rosterTabState}
                                isAdminOrOwner={isAdminOrOwner}
                                clubDetails={clubDetails}
                                clubType={clubType}
                                updateRosterTabState={props.updateRosterTabState}
                                isSchool={hasSchoolLinked(clubDetails)}
                                userIsPowered={userIsPowered}
                                power6Data={power6Data}
                            />
                        )}
                        {hasRoster ? (
                            <Roster
                                schoolDetails={schoolDetails}
                                rosterTabState={rosterTabState}
                                isAdminOrOwner={isAdminOrOwner}
                                clubDetails={clubDetails}
                                clubType={clubType}
                                featureGates={featureGates}
                                updateRosterTabState={props.updateRosterTabState}
                                user={auth.user}
                                showTennisRatings
                                showPickleBallRatings={false}
                                userIsPowered={userIsPowered}
                                checkGate={checkGate}
                            />
                        ) : (
                            <>
                                {isAdminOrOwner && !isHighSchool ? (
                                    <div className={`${styles.placeHolderGrid}`}>
                                        <div className={`${styles.overlay}`} />
                                        <div className={`${styles.actionWrapper}`}>
                                            <button
                                                type="button"
                                                className={`btn btn-primary btn-sm text-uppercase`}
                                                onClick={() => {
                                                    props.updateRosterTabState(props.rosterTabState);
                                                }}
                                            >
                                                Add Roster player
                                            </button>
                                        </div>
                                    </div>
                                ) : (
                                    <div className="row mt64">
                                        <div className="col-12">
                                            <p className="text-center">No players have been added yet<br />
                                                Check back for roster
                                            </p>
                                        </div>
                                    </div>
                                )}
                            </>
                        )}
                    </>
                </div>
            </div>
        </div>
    );
};

RosterTabContent.propTypes = {
    clubDetails: PropTypes.shape({
        id: PropTypes.number,
        tierType: PropTypes.shape({
            isCollege: PropTypes.bool,
            isHighSchool: PropTypes.bool,
        }),
    }).isRequired,
    schoolDetails: PropTypes.shape({
        roster: PropTypes.arrayOf(
            PropTypes.shape({
                id: PropTypes.number.isRequired,
                firstName: PropTypes.string.isRequired,
                lastName: PropTypes.string.isRequired,
                singlesRating: PropTypes.number,
                doublesRating: PropTypes.number,
                claimed: PropTypes.bool,
            }),
        ),
    }).isRequired,
    schoolDetailsState: PropTypes.shape({
        complete: PropTypes.bool,
        successful: PropTypes.bool,
    }).isRequired,
    auth: PropTypes.shape({
        user: PropTypes.shape({
            isPowered: PropTypes.bool,
        }),
    }).isRequired,
    clubType: PropTypes.string.isRequired,
    rosterTabState: PropTypes.objectOf(any).isRequired,
    updateRosterTabState: PropTypes.func.isRequired,
    power6Data: PropTypes.shape({
        power6Rating: PropTypes.number,
        power6HighRating: PropTypes.number,
        power6LowRating: PropTypes.number,
    }),
};

RosterTabContent.defaultProps = {
    power6Data: null,
};

export default RosterTabContent;
